import { renderButtonBlock } from '../render/blocks/button';
import { ButtonBlockSettings } from '../settings/blocks/button';
import { defineBlockRegistryEntry } from './defineEntry';
import { buttonBlockDefinition } from '../domain/blocks/button';
import { blockWidthAlignMargins } from '../domain/block-width';

export const buttonBlockRegistryEntry = defineBlockRegistryEntry(
  buttonBlockDefinition,
  renderButtonBlock,
  ButtonBlockSettings,
  {
    boxStyle: block =>
      block.type === 'button' && !block.fullWidth
        ? {
            width: 'fit-content',
            maxWidth: '100%',
            ...blockWidthAlignMargins(block.align),
          }
        : undefined,
  },
);
